// Minimal Web Audio pluck synth for note auditioning (Prepare screen taps).
// Kept tiny and side-effect free until first use.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!ctx) ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

const OPEN_MIDI: Record<number, number> = { 1: 64, 2: 59, 3: 55, 4: 50, 5: 45, 6: 40 };

export function fretToFreq(string: number, fret: number): number {
  const midi = (OPEN_MIDI[string] ?? 40) + fret;
  return 440 * Math.pow(2, (midi - 69) / 12);
}

/** Warm plucked tone with a gentle lowpass and quick decay. */
export function playPluck(freq: number, gain = 0.28): void {
  try {
    const ac = getCtx();
    const now = ac.currentTime;
    const osc = ac.createOscillator();
    const osc2 = ac.createOscillator();
    const filt = ac.createBiquadFilter();
    const g = ac.createGain();

    osc.type = "triangle";
    osc2.type = "sine";
    osc.frequency.value = freq;
    osc2.frequency.value = freq * 2;

    filt.type = "lowpass";
    filt.frequency.setValueAtTime(2600, now);
    filt.frequency.exponentialRampToValueAtTime(700, now + 0.5);

    g.gain.setValueAtTime(0.0001, now);
    g.gain.exponentialRampToValueAtTime(gain, now + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, now + 1.1);

    osc.connect(filt);
    osc2.connect(filt);
    filt.connect(g);
    g.connect(ac.destination);

    osc.start(now);
    osc2.start(now);
    osc.stop(now + 1.2);
    osc2.stop(now + 1.2);
  } catch {
    /* audio not available */
  }
}

export function playFretNote(string: number, fret: number): void {
  playPluck(fretToFreq(string, fret));
}
